import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
// import TeamImage from './TeamImage.png'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {SearchView} from '../SearchView/SearchView'
import {fetchMenusIfNeeded, selectCustomPage,
        fetchCustomPageIfNeeded, CLIENT_BASE_URL} from '../../actions'

export class TemplateImgTopLarge extends React.Component {

  constructor (props) {
    super(props)
    this.gotoPage = this.gotoPage.bind(this)
  }

  drawBackgroundImage (poster) {
    poster = CLIENT_BASE_URL + poster
    return {
      backgroundImage: `url('${poster}')`
    }
  }

  componentWillMount (p) {
    const {match, dispatch} = this.props
    // console.log('componentWillMount p', match.params.splat)

    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    } else {
      dispatch(selectCustomPage(''))
    }
  }

  componentDidMount () {
    const {dispatch, match} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
    if (Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]))
    } else {
      dispatch(selectCustomPage(''))
    }
  }

  componentWillReceiveProps (nextProps) {
    const {match, dispatch} = nextProps
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope))
    }

    const {selectedCustomPage} = this.props

    if (Object.keys(match.params).length && selectedCustomPage !== match.params[0]) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    }
  }

  componentWillUnmount () {
    const {match, dispatch} = this.props
    dispatch(selectCustomPage(''))
    if(match.params.length) {
        dispatch(fetchCustomPageIfNeeded(match.params[0]))
    }

  }

  gotoPage (page) {
    this.props.history.push('/pesquisa')
  }

  render () {
    const {menus, dispatch} = this.props
    const top_menus = menus.top || []
    const bottom_menus = menus.bottom || []
    const {details} = this.props
    if (!Object.keys(details).length) {
      return (
        <div></div>
        )
    }

    let mainHtmlClassName = ''
    if (parseInt(details['0'].num_text_cols, 10) === 2) {
      mainHtmlClassName = 'twocols'
    }

    // <div className='thumb topLargeImg' style={this.drawBackgroundImage(details['0'].poster)}></div>
    const topLargeImg = CLIENT_BASE_URL + details['0'].poster

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='presentation-view' className='row team-view'>
          <div className='col-md-12 no-pad text-left'>
            <p className='left-tag'>{details['0'].title}</p>
            <SearchView gotoPage={this.gotoPage} dispatch={dispatch} customStyle={'alignright'} />
          </div>
          <div className='row main-block'>
            <div className='col-sm-12'>
              <img className='thumb topLargeImg' src={topLargeImg} />
            </div>
            <div className='col-sm-12'>
              <div className='txt-block'>
                <p className={mainHtmlClassName} dangerouslySetInnerHTML={{ __html: details['0'].mainhtml }}></p>
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

TemplateImgTopLarge.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  details: PropTypes.object.isRequired,
  selectedCustomPage: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedCustomPage, getCustomPage, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  const {
    isFetchingCPage,
    items: details
  } = getCustomPage[selectedCustomPage] || {
    isFetchingCPage: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingCPage,
    details,
    selectedScope,
    selectedCustomPage
  }
}

export default connect(mapStateToProps)(TemplateImgTopLarge)



// WEBPACK FOOTER //
// ./src/views/AboutView/TemplateImgTopLarge.js